export const symbolDetailsScrollProgress = { current: 0 };
export const chartHeaderElementRef = { current: null as HTMLDivElement | null };
